export class BalanceModel {
    from: string;
    to: string;
    name: string;
    number: number;
    type: string;
    total: number;
    global: boolean;
}